<div class="claim_body">
    <div class="top_panel">
        <h3>{{modalHeading[data?.actionModal]}}</h3>
        <span (click)="close()" class="close">
            <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="formarea">
        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'updateWaitingPeriod'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Waiting Periods (Days)</mat-label>
                    <input matInput placeholder="Waiting Periods (Days)" formControlName="waitingPeriod" mask="0*">
                    <mat-error
                    *ngIf="data?.formGroup.controls['waitingPeriod'].touched && data?.formGroup.controls['waitingPeriod'].hasError('required')">
                    This is required field.
                </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'updateCustomerScore'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Customer Score</mat-label>
                    <mat-select matNativeControl formControlName="customerScore">
                        <mat-option *ngFor="let score of customerScores" [value]="score">{{score}}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="data?.formGroup.controls['customerScore'].touched && data?.formGroup.controls['customerScore'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'updateContactInfo'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matNativeControl formControlName="firstName" (keypress)="apiService.restrictSpecialChar($event)"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['firstName'].touched && data?.formGroup.controls['firstName'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matNativeControl formControlName="lastName" (keypress)="apiService.restrictSpecialChar($event)"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['lastName'].touched && data?.formGroup.controls['lastName'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matNativeControl formControlName="phoneNumber" mask="(000) 000-0000"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['phoneNumber'].touched && data?.formGroup.controls['phoneNumber'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    
                    <mat-label>Email Address</mat-label>
                 
                    <input matNativeControl formControlName="emailAddress"/>
                    <mat-error  *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('pattern')">
                        Enter Valid email address.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>

        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'updateAgreementHolderDetail'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>First Name</mat-label>
                    <input matNativeControl formControlName="firstName" (keypress)="apiService.restrictSpecialChar($event)"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['firstName'].touched && data?.formGroup.controls['firstName'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Last Name</mat-label>
                    <input matNativeControl formControlName="lastName" (keypress)="apiService.restrictSpecialChar($event)"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['lastName'].touched && data?.formGroup.controls['lastName'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Phone Number</mat-label>
                    <input matNativeControl formControlName="phoneNumber"  mask="(000) 000-0000"/>
                    <mat-error
                        *ngIf="data?.formGroup.controls['phoneNumber'].touched && data?.formGroup.controls['phoneNumber'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="auto" appearance="outline">
                    
                    <mat-label>Email Address</mat-label>
                 
                    <input matNativeControl formControlName="emailAddress"/>
                    <mat-error  *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('required')">
                        This is required field.
                    </mat-error>
                    <mat-error *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('pattern')">
                        Enter Valid email address.
                    </mat-error>
                </mat-form-field>
            </div>
        </form>
        <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'sendEscrowConfirmationMail'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                <mat-label>Recipient's Email Address</mat-label>
                    <input matInput placeholder="Recipient's Email Address" formControlName="emailAddress">
                <mat-error
                    *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('required')">
                    This is required field.
                </mat-error>
                <mat-error
                    *ngIf="data?.formGroup.controls['emailAddress'].touched && data?.formGroup.controls['emailAddress'].hasError('pattern')">
                    Enter valid email address.
                </mat-error>
                </mat-form-field>
            </div>
        </form>

         <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'updateFreeMonth'">
            <div class="inputprt">
                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Free Month</mat-label>
                    <input matInput placeholder="Free Month" formControlName="freeMonth" mask="0*">
                    <mat-error
                    *ngIf="data?.formGroup.controls['freeMonth'].touched && data?.formGroup.controls['freeMonth'].hasError('required')">
                    This is required field.
                </mat-error>
                </mat-form-field>
            </div>
        </form>
        
        <!-- <form [formGroup]="data?.formGroup"   *ngIf="data?.actionModal === 'escalateClaim'">
            <div class="inputprt">

                <mat-form-field fxFlex="auto" appearance="outline">
                    <mat-label>Supervisor</mat-label>
                    <mat-select matNativeControl formControlName="value">
                        <mat-option *ngFor="let item of agents"
                            value="{{item?.userId}}">{{commonService.getFullName(item?.firstName,
                            item?.lastName)}}</mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="data?.formGroup.controls['value'].touched && data?.formGroup.controls['value'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
                
                <mat-form-field fxFlex="auto" appearance="outline" class="fullwidth">
                    <mat-label>Note</mat-label>
                    <textarea
                    matInput
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="5"
                    cdkAutosizeMaxRows="5"
                    formControlName="note"
                  ></textarea>
                    <mat-error
                        *ngIf="data?.formGroup.controls['note'].touched && data?.formGroup.controls['note'].hasError('required')">
                        This is required field.
                    </mat-error>
                </mat-form-field>
            </div>
        </form> -->

        <div class="actions" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="8px">
            <button mat-button type="button" class="sub-button" (click)="onSubmit()"><span>{{modalButtonText[data?.actionModal]}}</span></button>
            <button mat-button type="button" class="can-button" (click)="close()"><span>Cancel</span></button>
        </div>
    </div>
</div>